import GlobalStyles from '@mui/material/GlobalStyles';
import * as React from 'react';

export const AppMainStyle = (
  <GlobalStyles
    styles={theme => ({
      ':root': {
        '--color-primary': theme.palette.primary.main,
        '--color-secondary': theme.palette.secondary.main,
        '--text-primary': theme.palette.text.primary,
        '--bg-white': theme.palette.white,
        '--grey-0': theme.palette.grey[0],
        '--grey-50': theme.palette.grey[50],
        '--grey-100': theme.palette.grey[100],
        '--grey-200': theme.palette.grey[200],
        '--grey-300': theme.palette.grey[300],
        '--grey-400': theme.palette.grey[400],
        '--grey-500': theme.palette.grey[500],
        '--grey-600': theme.palette.grey[600],
        '--grey-700': theme.palette.grey[700],
        '--grey-800': theme.palette.grey[800],
        '--grey-900': theme.palette.grey[900],
        '--bluegrey-100': theme.palette.bluegrey[100],
        '--bluegrey-200': theme.palette.bluegrey[200],
        '--bluegrey-300': theme.palette.bluegrey[300],
        '--bluegrey-400': theme.palette.bluegrey[400],
        '--bluegrey-500': theme.palette.bluegrey[500],
        '--bluegrey-600': theme.palette.bluegrey[600],
        '--bluegrey-700': theme.palette.bluegrey[700],
        '--bluegrey-800': theme.palette.bluegrey[800],
        '--bluegrey-900': theme.palette.bluegrey[900],
        '--primary-50': theme.palette.primary[50],
        '--primary-100': theme.palette.primary[100],
        '--primary-200': theme.palette.primary[200],
        '--primary-300': theme.palette.primary[300],
        '--primary-400': theme.palette.primary[400],
        '--primary-500': theme.palette.primary[500],
        '--primary-600': theme.palette.primary[600],
        '--primary-700': theme.palette.primary[700],
        '--primary-800': theme.palette.primary[800],
        '--primary-900': theme.palette.primary[900],
        '--secondary-50': theme.palette.secondary[50],
        '--secondary-100': theme.palette.secondary[100],
        '--secondary-200': theme.palette.secondary[200],
        '--secondary-300': theme.palette.secondary[300],
        '--secondary-400': theme.palette.secondary[400],
        '--secondary-500': theme.palette.secondary[500],
        '--secondary-600': theme.palette.secondary[600],
        '--secondary-700': theme.palette.secondary[700],
        '--secondary-800': theme.palette.secondary[800],
        '--secondary-900': theme.palette.secondary[900],
        '--warning-50': theme.palette.warning[50],
        '--warning-100': theme.palette.warning[100],
        '--warning-200': theme.palette.warning[200],
        '--warning-300': theme.palette.warning[300],
        '--warning-400': theme.palette.warning[400],
        '--warning-500': theme.palette.warning[500],
        '--warning-600': theme.palette.warning[600],
        '--warning-700': theme.palette.warning[700],
        '--warning-800': theme.palette.warning[800],
        '--warning-900': theme.palette.warning[900],
        '--success-50': theme.palette.success[50],
        '--success-100': theme.palette.success[100],
        '--success-200': theme.palette.success[200],
        '--success-300': theme.palette.success[300],
        '--success-400': theme.palette.success[400],
        '--success-500': theme.palette.success[500],
        '--success-600': theme.palette.success[600],
        '--success-700': theme.palette.success[700],
        '--success-800': theme.palette.success[800],
        '--success-900': theme.palette.success[900],
        '--error-50': theme.palette.error[50],
        '--error-100': theme.palette.error[100],
        '--error-200': theme.palette.error[200],
        '--error-300': theme.palette.error[300],
        '--error-400': theme.palette.error[400],
        '--error-500': theme.palette.error[500],
        '--error-600': theme.palette.error[600],
        '--error-700': theme.palette.error[700],
        '--error-800': theme.palette.error[800],
        '--error-900': theme.palette.error[900],
        '--info-50': theme.palette.info[50],
        '--info-100': theme.palette.info[100],
        '--info-200': theme.palette.info[200],
        '--info-300': theme.palette.info[300],
        '--info-400': theme.palette.info[400],
        '--info-500': theme.palette.info[500],
        '--info-600': theme.palette.info[600],
        '--info-700': theme.palette.info[700],
        '--info-800': theme.palette.info[800],
        '--info-900': theme.palette.info[900],
        '--headerHeight': '50px',
        '--PageToolbarHeight': '55px',
        '--footerHeight': '32px',
      },
      '.markdown table': {
        borderCollapse: '',
        borderSpacing: 0,
        tableLayout: 'auto',
      },
      '.markdown th': {
        fontSize: '13px',
        textAlign: 'left',
        color: '#333',
        backgroundColor: 'var(--grey-200)',
        borderColor: 'var(--grey-200)',
        padding: '.25rem .75rem',
        borderTopWidth: '1px',
        borderLeftWidth: '1px',
      },
      '.markdown th:first-of-type': {
        borderTopLeftRadius: '.375rem',
      },
      '.markdown th:last-child': {
        borderTopRightRadius: '.375rem',
      },
      '.markdown td': {
        border: 'solid 1px var(--grey-200)',
        fontSize: '13px',
        backgroundColor: '#fff',
        padding: '.25rem .75rem',
        borderLeftWidth: '1px',
        borderBottomWidth: '1px',
      },
      '.markdown tr:last-child td:first-of-type': {
        borderBottomLeftRadius: '.375rem',
      },
      '.markdown tr:last-child td:last-child': {
        borderBottomRightRadius: '.375rem',
      },
      '.ql-table-embed': {
        overflowX: 'auto',
        margin: '16px 0',
      },
      '.ql-table-embed table': {
        borderCollapse: 'collapse',
        borderSpacing: 0,
        tableLayout: 'auto',
        width: '100%',
      },
      '.ql-table-embed th': {
        fontSize: '13px',
        textAlign: 'left',
        color: '#333',
        fontWeight: 600,
        backgroundColor: 'var(--grey-200)',
        borderColor: 'var(--grey-200)',
        padding: '.25rem .75rem',
        border: 'solid 1px var(--grey-200)',
      },
      '.ql-table-embed td': {
        border: 'solid 1px var(--grey-200)',
        fontSize: '13px',
        backgroundColor: '#fff',
        padding: '.25rem .75rem',
      },
      '.ql-table-embed tr:nth-of-type(2n)': {
        backgroundColor: '#f6f8fa',
      },
      '.ql-table-embed th:first-of-type': {
        borderTopLeftRadius: '.375rem',
      },
      '.ql-table-embed th:last-child': {
        borderTopRightRadius: '.375rem',
      },
      '.ql-table-embed tr:last-child td:first-of-type': {
        borderBottomLeftRadius: '.375rem',
      },
      '.ql-table-embed tr:last-child td:last-child': {
        borderBottomRightRadius: '.375rem',
      },
      '.datagrid-toolbar .DG-SearchBar-Filled': {
        background: 'var(--grey-100)',
        borderRadius: '50px',
        padding: '1px 8px 1px 12px',
        border: '1px solid var(--grey-300)',
      },
      '.datagrid-toolbar [aria-label="Search"] .MuiInput-root:before, .datagrid-toolbar [aria-label="Search"] .MuiInput-root:after':
        {
          display: 'none',
        },
    })}
  />
);
